import { HttpClient } from 'Mri.Web.Common';

export class AuditStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public async logPageView(page: string, displaySerialNumber?: string | null) {
        await this.httpClient.post<Mri.Audit.AuditLog<Mri.Audit.DownloadedDocumentLog>>(
            `/api/v1/audit-log/viewed-page`,
            null,
            {
                params: {
                    page,
                    displaySerialNumber,
                },
            }
        );
    }

    private readonly httpClient: HttpClient;
}
